import { render, staticRenderFns } from "./PersonelConflictReport.vue?vue&type=template&id=372ad640&"
import script from "./PersonelConflictReport.vue?vue&type=script&lang=js&"
export * from "./PersonelConflictReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports